export class CodigoErroConstante
{
    public static GOVBR_NIVEL_INVALIDO: string = 'GOV_BR_NIVEL_INVALIDO_ASSINATURA';
    public static SESSAO_GOVBR_EXPIRADA: string = 'SESSAO_GOVBR_EXPIRADA';
}
